<template>
  <div>
    <v-btn
      v-if="!clickTrial"
      icon
      class="ml-7"
      style="position: absolute; left: 15px; z-index: 4"
      @click="back()"
    >
      <v-icon color="secondary" style="font-size: 45px"
        >mdi-chevron-left</v-icon
      >
    </v-btn>
    <div class="mt-5">
      <v-tabs v-model="tabs" name="fade" class="setTab">
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tabs-1" class="primary--text" @click="togglePage = false">
          <span>{{ $t('Package') }}</span>
        </v-tab>

        <v-tab href="#tabs-2" class="primary--text">
          <span>{{ $t('Your Package') }}</span>
        </v-tab>
      </v-tabs>
    </div>

    <v-tabs-items v-model="tabs" class="mb-5" mode="fade">
      <v-tab-item
        :value="'tabs-1'"
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <v-container>
          <h3 class="mb-5">
            {{ $t(`Choose the plan that's right for you`) }}
          </h3>
          <!-- May rollback -->
          <template v-if="false">
            <v-card
              outlined
              style="padding: 8px; width: 100%; color: #ffffff"
              class="l0 text-center mb-5"
              :style="{ background: '#FD1267' }"
            >
              <h2>Promotion</h2>
              <!-- <h2 v-else>Unlock Package</h2> -->
            </v-card>
            <v-row class="fill-height">
              <template v-for="(item, i) in items">
                <v-col
                  :key="i"
                  cols="12"
                  sm="6"
                  md="4"
                  lg="4"
                  style="text-align: -webkit-center"
                >
                  <v-card
                    style="border: none !important; width: 70%"
                    outlined
                    class="r0 pa-0"
                    @click="selectPlan(item)"
                  >
                    <!-- <v-card
                      outlined
                      style="
                        padding: 8px;
                        width: 100%;
                        position: absolute;
                        top: -20px;
                        left: -35px;
                        color: #ffffff;
                      "
                      class="l0 text-center"
                      :style="{ background: item.color }"
                    >
                      <h3>{{ item.title }}</h3>
                    </v-card> -->
                    <v-card-title>
                      <v-row class="fill-height flex-column text-center">
                        <h2 class="mt-7 ma-0">
                          {{ item.piecesNumber }} {{ $t('pieces') }}
                        </h2>
                        <h3 class="mb-7">
                          {{ $t(item.piecesText) }}
                        </h3>
                        <!-- <small class="light-weight mb-5">{{
                          `( ${item.day} ${$t("days")} )`
                        }}</small> -->
                      </v-row>
                    </v-card-title>
                    <v-card
                      outlined
                      style="
                        padding: 6px;
                        width: 60%;
                        position: absolute;
                        color: rgb(255, 255, 255);
                        top: 79%;
                        right: -20%;
                      "
                      class="r0 text-center"
                      :style="{ background: item.color }"
                    >
                      <h2>{{ item.priceNumber | numberFormat }} ฿</h2>
                    </v-card>
                  </v-card>
                  <div class="text-center mt-10">
                    <v-btn
                      outlined
                      rounded
                      class="btn-custom bg-plan-btn mb-15 mb-md-1"
                      style="
                        width: 70%;
                        height: 28px;
                        border-bottom-right-radius: 38px !important;
                      "
                      @click="selectPlan(item)"
                    >
                      {{ $t('Buy now') }}
                    </v-btn>
                  </div>
                </v-col>
              </template>
            </v-row>
            <div v-if="false" id="promotion">
              <transition name="fade">
                <template v-if="togglePage">
                  <packages-confirm
                    v-model="planSelect"
                    class="mt-10"
                  ></packages-confirm>
                </template>
              </transition>
            </div>

            <v-card
              style="border: none !important"
              outlined
              class="r0 text-left mt-10 pa-10"
            >
              <h3 class="mb-6">{{ $t('Conditions') }}</h3>
              <template v-for="(item, i) in Conditions">
                <div :key="i" style="display: flex">
                  <div class="dot mr-6"></div>
                  <p>{{ $t(item.text) }}</p>
                </div>
              </template>
            </v-card>
          </template>

          <!-- New plan -->
          <template v-if="true">
            <v-row class="align-center">
              <v-col cols="12" sm="6">
                <v-card
                  outlined
                  style="padding: 8px; width: 100%; color: #ffffff"
                  class="l0 text-center mb-5"
                  :style="{ background: '#FD1267' }"
                >
                  <h2>Promotion</h2>
                </v-card>
                <v-card class="rounded-xl" elevation="4">
                  <v-card-text>
                    <div class="d-flex justify-center">
                      <div
                        class="mx-1 display-1 font-weight-bold"
                        style="
                          font-family: Kanit, Fallback, sans-serif !important;
                        "
                      >
                        50 {{ $t('pieces') }}
                      </div>
                      <div
                        class="mx-1 display-1 font-weight-bold align-self-end"
                        style="
                          font-family: Kanit, Fallback, sans-serif !important;
                          color: var(--primary-color);
                        "
                      >
                        1,999 {{ $t('฿') }}
                      </div>
                    </div>
                    <!-- <div class="d-flex justify-center title font-weight-medium mt-1" style="font-family: Kanit, Fallback, sans-serif !important;color: var(--primary-color)">
                      {{ $t('discount_from') }} <span class="text-decoration-line-through mx-2">3,998</span> {{ $t('฿') }}
                    </div> -->
                  </v-card-text>
                </v-card>
                <v-dialog v-model="dialog" persistent max-width="800px">
                  <template #activator="{ on, attrs }">
                    <v-btn
                      class="mt-4 white--text"
                      color="#FD1267"
                      block
                      elevation="2"
                      style="border-radius: 20px 20px 20px 0"
                      v-bind="attrs"
                      @click="setCreditCard"
                      v-on="on"
                    >
                      {{ $t('Buy now') }}
                    </v-btn>
                  </template>
                  <v-card style="padding-bottom: 20px">
                    <div
                      class="pointer"
                      style="float: right; margin-right: 30px; margin-top: 10px"
                    >
                      <v-icon @click="dialog = false">mdi-close</v-icon>
                    </div>
                    <v-card-title
                      v-if="dialog"
                      style="place-content: center; display: block"
                    >
                      <credit-card
                        v-model="request"
                        @closeDialog="closeDialog"
                      ></credit-card> </v-card-title
                  ></v-card>
                </v-dialog>
                <v-card
                  style="border: none !important"
                  outlined
                  class="r0 text-left mt-10 pa-10"
                >
                  <h3 class="mb-6">{{ $t('Conditions') }}</h3>
                  <div :key="i" style="display: flex">
                    <div class="dot mr-6"></div>
                    <p>{{ $t('conditions.1') }}</p>
                  </div>
                  <!-- <div :key="i" style="display: flex">
                    <div class="dot mr-6"></div>
                    <p>{{ $t('conditions.2') }}</p>
                  </div> -->
                  <div :key="i" style="display: flex">
                    <div class="dot mr-6"></div>
                    <p>
                      {{ $t('conditions.3') }},
                      <a
                        href="https://m.me/361231620965547?ref=ริชเมนูราคาเท่าไหร่"
                        target="_blank"
                        class="text-decoration-none font-weight-bold"
                        style="color: #fd1267"
                        >{{ $t('Contact us').toLowerCase() }}</a
                      >
                    </p>
                  </div>
                  <div :key="i" style="display: flex">
                    <div class="dot mr-6"></div>
                    <p>{{ $t('conditions.4') }}</p>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6">
                <img
                  :src="getImage('image/package/richmenu13.png')"
                  width="100%"
                />
              </v-col>
            </v-row>
          </template>
        </v-container>
      </v-tab-item>
      <v-tab-item
        :value="'tabs-2'"
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <v-container>
          <h3 class="mb-5">{{ $t('You are using premium package') }}</h3>

          <v-card
            class="r0 pl-4 pr-4 pl-sm-8 pr-sm-0 pt-7 mb-15"
            style="position: relative; padding: 15px"
          >
            <v-row>
              <v-col>
                <div class="dot mt-1 mr-4 ml-0 ml-sm-8 d-inline-block"></div>
                <h4 class="light-weight d-inline-block">
                  {{ $t('Your Package') }}
                </h4>
              </v-col>
              <v-col>
                <v-dialog
                  v-if="packageGroup.length === 0"
                  v-model="toggleRemark"
                  width="500"
                >
                  <template #activator="{ on }">
                    <v-btn
                      v-if="$vuetify.breakpoint.name !== 'xs'"
                      outlined
                      class="btn-custom-outline btn-remember"
                      v-on="on"
                    >
                      {{ $t('Read free trial terms') }}</v-btn
                    >
                  </template>

                  <v-card style="opacity: 1">
                    <v-card-title class="lighten-2" primary-title>
                      {{ $t('free trial terms') }}
                    </v-card-title>

                    <v-card-text>
                      <ul>
                        <li>
                          {{
                            $t(
                              'Customers who apply for the new Rich menu can edit settings 2 times, free for 7 days.'
                            )
                          }}
                        </li>
                        <li>
                          {{
                            $t(
                              "After 7 days, if the Rich menu is installed on Line OA, the Rich menu will still be available. but can't edit, can only press 'Disconnect' or 'Unlock to edit'."
                            )
                          }}
                        </li>
                      </ul>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" flat @click="toggleRemark = false">
                        {{ $t('Back') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
              <v-col class="text-center text-sm-right">
                <div style="position: inherit">
                  <v-card
                    outlined
                    class="r0 d-inline-block pr-3 pa-3 bg-two-tone text-center color-white"
                    style="
                      width: 250px;
                      border: none !important;
                      margin-top: -28px;
                    "
                  >
                    <h1 v-if="packageGroup.length !== 0" class="f-36">
                      {{ allPiece }} {{ $t('Piece') }}
                    </h1>
                    <h1 v-else>{{ $t('Free') }}</h1>
                  </v-card>
                </div>
              </v-col>
            </v-row>
            <div v-if="packageGroup.length !== 0">
              <template v-for="(group, i) in packageGroup">
                <div :key="`group_${i}`">
                  <v-row no-gutters class="text-center text-sm-left">
                    <v-col cols="12" class="py-2">
                      <v-row no-gutters>
                        <v-col>
                          <div
                            class="dot mt-1 mr-4 ml-0 ml-sm-8 d-inline-block"
                          ></div>
                          <h4 class="light-weight d-inline-block">
                            {{ group.piece }}
                            {{ $t('Piece') }}
                          </h4>
                        </v-col>
                        <v-col>
                          <span style="vertical-align: middle">
                            {{ $i18n.locale === 'th' ? 'ราคา' : '' }}
                            {{ group.amount }} {{ $t('Baht').toLowerCase() }}
                          </span>
                        </v-col>
                        <v-col>
                          <span style="vertical-align: middle">
                            {{ $t('purchase_date') }}
                            {{ formatExpiredDate(group.created_at) }}</span
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </template>
            </div>
            <div v-else>
              <v-row no-gutters class="text-center text-sm-left">
                <v-col cols="12" class="py-2">
                  <v-row no-gutters>
                    <v-col>
                      <div
                        class="dot mt-1 mr-4 ml-0 ml-sm-8 d-inline-block"
                      ></div>
                      <h4 class="light-weight d-inline-block">
                        2
                        {{ $t('Piece') }}
                      </h4>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import PackagesConfirm from '../components/PackagesConfirm'
import CreditCard from '../components/account/CreditCard'

import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import apiClient from '@/services/apiService'
export default {
  components: {
    PackagesConfirm,
    CreditCard
  },
  computed: {
    ...mapGetters({
      lineRichmenu: 'lineRichmenuManager/getLineRichMenu',
      clickTrial: 'lineRichmenuManager/getClickTrial',
      IdCreditCard: 'packagePlan/getIdCreditCard',
      GroupId: 'lineRichmenuManager/getGroupId'
    })
  },
  data: () => ({
    allPiece: 0,
    toggleRemark: false,
    dialog: false,
    togglePage: false,
    packageGroup: [],
    planSelect: {},
    gbpReferenceNo: '',
    request: {},
    items: [
      // {
      //   title: "Basic (Bata)",
      //   priceNumber: "1",
      //   piecesNumber: "2",
      //   piecesText: "per month",
      //   day: "30",
      //   color: "#FE9999",
      // },
      {
        title: 'Promotion',
        priceNumber: '99',
        piecesNumber: '2',
        piecesText: '',
        day: '30',
        color: '#FE9999'
      },
      {
        title: 'Promotion',
        priceNumber: '239',
        piecesNumber: '5',
        piecesText: '',
        day: '30',
        color: 'var(--v-primary-lighten2)'
      },
      {
        title: 'Promotion',
        priceNumber: '1999',
        piecesNumber: '50',
        piecesText: '',
        day: '30',
        color: '#FD1267'
      }
    ],
    /* Conditions: [
      {
        text:
          "Rich menu purchased can be edited unlimited. (Promotion only for customers within 31 December 2023).",
      },
      {
        text:
          "Starting package: 2 pieces Package / 5 pieces Package / 50 pieces Package",
      },
      {
        text:
          "To add capacity of the main package, pay 69 baht/piece (Each item’s expiry date depends on chosen main package)",
      },
      {
        text: "No refund policy",
      },
    ], */
    tabs: 'tabs-1'
  }),
  mounted() {
    // console.log(this.$route.params.page);
    // if (this.$route.params.page === "yourpackages") {
    //   this.tabs = "tabs-2";
    // } else {
    //   if (this.$route.params.groupID !== "1") {
    //     this.items[0].title = "Unlock Package";
    //     this.selectPlan(this.items[0]);
    //   }
    // }

    this.getLineRichmenuPackageByAccount()
  },
  methods: {
    scrollPackage() {
      this.$vuetify.goTo(document.querySelector('#promotion'))
    },
    async getLineRichmenuPackageByAccount() {
      const business_id = sessionStorage.getItem('businessId')
      var res = await apiClient.get(
        'line_richmenu_package_payment_by_account',
        { business_id }
      )
      console.log(res)
      if (res) {
        this.packageGroup = res.data.data
        this.packageGroup.forEach((element) => {
          this.allPiece += parseInt(element.piece)
        })
      } else {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Error',
          text: `Something went wrong.`
        })
      }
    },
    getPiece(p) {
      var res
      this.items.map((item) => {
        if (p === item.priceNumber) {
          res = item.piecesNumber
        }
      })
      return res
    },
    checkAddOn(p, qouta) {
      var a
      this.items.map((item) => {
        if (p === item.priceNumber) {
          a = item.piecesNumber
        }
      })
      return qouta - a
    },
    selectPlan(item) {
      this.scrollPackage()
      this.planSelect = item
      this.togglePage = false
      this.$nextTick(() => {
        this.togglePage = true
      })
    },
    closeDialog() {
      this.dialog = false
    },
    back() {
      if (this.togglePage && !this.GroupId.is_free) {
        this.togglePage = false
      } else {
        const path = `/${localStorage.getItem('language') || 'th'}/richmenu`
        if (this.$route.path !== path) {
          this.$router.push({ path })
        }
      }
    },
    formatExpiredDate(date) {
      this.expiredDate = date
      return dayjs(date).format('DD/MM/YYYY - HH.mm')
    },
    addNewDuringMonth(expiredDate) {
      const date1 = new Date()
      const date2 = new Date(expiredDate)
      const diffTime = Math.abs(date2 - date1)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      return diffDays
    },

    closeDialogGroup(groupID) {
      this.$set(this.dialog, groupID, false)
    },

    setCreditCard() {
      this.request = {
        service: 'line_richmenu',
        amount: 1999,
        payment: {
          type: 'credit_card',
          credit_card_id: this.IdCreditCard
        },
        action: {
          type: 'buy',
          name: '50',
          package: 50,
          addon: 1,
          trial_line_richmenu_id: null,
          price: 1999,
          amount: 50
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
.setTab {
  border-radius: 41px 41px 0px 41px;
  width: 325px;
  margin: auto;
}
.setTabTemplate {
  border-radius: 41px 41px 0px 41px;
  width: 325px;
}
.dot {
  background: var(--v-primary-lighten2);
  min-width: 17px;
  width: 17px;
  height: 17px;
  border-radius: 14px 14px 0px 14px;
}
.dot2 {
  background: #fd1267;
  min-width: 17px;
  width: 17px;
  height: 17px;
  border-radius: 6px 6px 6px 0px;
}
.f-36 {
  font-size: 36px;
  height: 40px;
}
.btn-remember {
  width: 180px;
  border-radius: 38px 38px 38px 38px !important;
  text-transform: none !important;
}
.btn-cancelmember {
  border: 3px solid var(--v-primary-lighten3);
  width: 180px;
  border-radius: 38px 38px 38px 38px !important;
  text-transform: none !important;
  span {
    color: #ff0000;
    font-weight: 400;
  }
}
.right {
  text-align: -webkit-right;
}
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.expired-card {
  border: red 3px solid;
}
</style>
